var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnvironmentHiro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1024,
    viewBox: "0 0 1440 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_275_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "#EBDCB7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -36,
    y: 692,
    width: 1492,
    height: 346,
    fill: "#331414"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 362,
    width: 153,
    height: 9,
    fill: "#C87749"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 552,
    y: 191,
    width: 153,
    height: 9,
    fill: "#C87749"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 557,
    y: 277,
    width: 153,
    height: 9,
    fill: "#C87749"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.652 167.566C636.308 165.156 638.178 163 640.612 163H656.469C658.875 163 660.736 165.109 660.438 167.496L657.938 187.496C657.688 189.498 655.986 191 653.969 191H643.469C641.479 191 639.791 189.536 639.509 187.566L636.652 167.566Z",
    fill: "url(#paint0_linear_275_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.652 253.566C557.308 251.156 559.178 249 561.612 249H577.469C579.875 249 581.736 251.109 581.438 253.496L578.938 273.496C578.688 275.498 576.986 277 574.969 277H564.469C562.479 277 560.791 275.536 560.509 273.566L557.652 253.566Z",
    fill: "url(#paint1_linear_275_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.652 253.566C600.308 251.156 602.178 249 604.612 249H620.469C622.875 249 624.736 251.109 624.438 253.496L621.938 273.496C621.688 275.498 619.986 277 617.969 277H607.469C605.479 277 603.791 275.536 603.509 273.566L600.652 253.566Z",
    fill: "url(#paint2_linear_275_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.652 253.566C643.308 251.156 645.178 249 647.612 249H663.469C665.875 249 667.736 251.109 667.438 253.496L664.938 273.496C664.688 275.498 662.986 277 660.969 277H650.469C648.479 277 646.791 275.536 646.509 273.566L643.652 253.566Z",
    fill: "url(#paint3_linear_275_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.652 253.566C679.308 251.156 681.178 249 683.612 249H699.469C701.875 249 703.736 251.109 703.438 253.496L700.938 273.496C700.688 275.498 698.986 277 696.969 277H686.469C684.479 277 682.791 275.536 682.509 273.566L679.652 253.566Z",
    fill: "url(#paint4_linear_275_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.652 167.566C674.308 165.156 676.178 163 678.612 163H694.469C696.875 163 698.736 165.109 698.438 167.496L695.938 187.496C695.688 189.498 693.986 191 691.969 191H681.469C679.479 191 677.791 189.536 677.509 187.566L674.652 167.566Z",
    fill: "url(#paint5_linear_275_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.652 167.566C560.308 165.156 562.178 163 564.612 163H580.469C582.875 163 584.736 165.109 584.438 167.496L581.938 187.496C581.688 189.498 579.986 191 577.969 191H567.469C565.479 191 563.791 189.536 563.509 187.566L560.652 167.566Z",
    fill: "url(#paint6_linear_275_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.652 167.566C598.308 165.156 600.178 163 602.612 163H618.469C620.875 163 622.736 165.109 622.438 167.496L619.938 187.496C619.688 189.498 617.986 191 615.969 191H605.469C603.479 191 601.791 189.536 601.509 187.566L598.652 167.566Z",
    fill: "url(#paint7_linear_275_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677 337C681.418 337 685.067 340.779 682.89 344.624C680.61 348.649 676.538 352.353 670.941 355.385C661.939 360.261 649.73 363 637 363C624.27 363 612.061 360.261 603.059 355.385C597.462 352.353 593.39 348.649 591.11 344.624C588.933 340.779 592.582 337 597 337L637 337H677Z",
    fill: "url(#paint8_linear_275_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.5 327.5C641.5 329 632.5 337 632.5 337H643C643 337 647.5 329.5 647.5 328C647.5 326.5 645 323.5 645 323.5C645 323.5 633 322 630.5 321C628 320 628.5 315 628.5 315L625 314.5C625 314.5 624.5 321.5 627.5 323.5C630.5 325.5 641.5 326 641.5 327.5Z",
    fill: "#773C1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.303 318.27C615.803 318.27 608.802 317.27 606.803 315.27C604.803 313.27 595.605 315.04 598.303 310.27C601 305.5 607.772 304 613.5 304C619.228 304 626 306.77 626.803 306.77C627.606 306.77 626.803 304.77 633.803 305.77C640.803 306.77 647.303 311.77 647.303 311.77C647.303 311.77 657.303 314.27 657.303 317.27C657.303 320.27 643 320 638.803 319.27C634.605 318.54 632.303 317.27 630.803 317.27C629.303 317.27 624.803 318.27 620.303 318.27Z",
    fill: "#1D5E13"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 789,
    y: 431,
    width: 180,
    height: 11,
    fill: "#112E3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.285 369.377C811.46 365.196 814.923 362 819.107 362H918.791C923.033 362 926.525 365.282 926.646 369.523C927.164 387.703 927.174 432.542 914.684 432.542C899.018 432.542 844.354 432.542 825.355 432.542C810.168 432.542 810.529 387.462 811.285 369.377Z",
    fill: "#435761"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1100,
    cy: 290.429,
    rx: 40,
    ry: 47.4286,
    fill: "#7D402D"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1100,
    cy: 289.857,
    rx: 30.8571,
    ry: 36.5714,
    fill: "#E6D3D3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1098.29,
    cy: 266.429,
    r: 5.14286,
    fill: "#44352C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1084.3 320.728C1083.72 320.156 1085.03 318.663 1085.78 315.267C1086.53 311.871 1087.58 308.796 1088.88 306.216C1090.17 303.636 1091.67 301.603 1093.3 300.232C1094.94 298.862 1096.66 298.18 1098.39 298.227C1100.11 298.274 1101.8 299.048 1103.36 300.505C1104.91 301.962 1106.31 304.074 1107.46 306.72C1108.6 309.366 1109.49 312.494 1110.06 315.926C1110.62 319.357 1111.72 321.871 1111.72 323.013C1111.72 324.156 1104.3 327.014 1097.63 326.364C1090.96 325.714 1084.87 321.299 1084.3 320.728Z",
    fill: "#5EB6AB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1085.14,
    y: 269.286,
    width: 27.4286,
    height: 21.7143,
    rx: 8,
    fill: "#44342C"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1098.86,
    cy: 284.714,
    rx: 11.4286,
    ry: 13.1429,
    fill: "#E3A886"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1088.57,
    y: 271.571,
    width: 20.5714,
    height: 10.2857,
    rx: 5.14286,
    fill: "#44342C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.839 573.517C510.885 568.582 514.666 564 519.693 564H646.766C651.638 564 655.379 568.318 654.684 573.14L637.987 689.14C637.421 693.077 634.047 696 630.069 696H542.102C538.269 696 534.975 693.281 534.248 689.517L511.839 573.517Z",
    fill: "#435761"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_275_2",
    x1: 648.5,
    y1: 163,
    x2: 648.5,
    y2: 191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#73C1CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A7681"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_275_2",
    x1: 569.5,
    y1: 249,
    x2: 569.5,
    y2: 277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#73C1CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A7681"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_275_2",
    x1: 612.5,
    y1: 249,
    x2: 612.5,
    y2: 277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#73C1CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A7681"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_275_2",
    x1: 655.5,
    y1: 249,
    x2: 655.5,
    y2: 277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#73C1CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A7681"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_275_2",
    x1: 691.5,
    y1: 249,
    x2: 691.5,
    y2: 277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#73C1CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A7681"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_275_2",
    x1: 686.5,
    y1: 163,
    x2: 686.5,
    y2: 191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#73C1CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A7681"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_275_2",
    x1: 572.5,
    y1: 163,
    x2: 572.5,
    y2: 191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#73C1CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A7681"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_275_2",
    x1: 610.5,
    y1: 163,
    x2: 610.5,
    y2: 191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#73C1CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A7681"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_275_2",
    x1: 637,
    y1: 311,
    x2: 637,
    y2: 363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0E8EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#257F8B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_275_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvironmentHiro);
export default __webpack_public_path__ + "static/media/environment_hiro.48b19d33ba6b2a813f121f1563f29419.svg";
export { ForwardRef as ReactComponent };